import { render, staticRenderFns } from "./MethodOption.vue?vue&type=template&id=13113309&scoped=true&"
import script from "./MethodOption.vue?vue&type=script&lang=js&"
export * from "./MethodOption.vue?vue&type=script&lang=js&"
import style0 from "./MethodOption.vue?vue&type=style&index=0&id=13113309&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13113309",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VIcon,VRadio,VRadioGroup})
